// 中文简体

export const main = {
  KubuqiOfficialWebsite: '库布其奖',
  // 导航信息
  homePage: '首页',
  backgroundOfTheCompetition: '大赛背景',
  latestNews: '最新资讯',
  previousCompetition: '第一届比赛花絮',
  firstCompetition: '第一届库布其大赛',
  previousCompetitionTwo: '第二届比赛花絮',
  firstCompetitionTwo: '第二届库布其大赛',
  secondCompetition: '网上公众投票',
  secondBackText:
    '第二届库布其奖 - 「谈谈可持续」中学生短片比赛反应踊跃，收到超过100条参赛短片。评审团已选出15条入围短片供公众在网上投票，投票结果占总成绩的20%，每一票都至关重要！',
  active: '「谈谈可持续」短片投票',
  pastGames: '过往比赛',
  topUniversity: '大学组获奖名单',
  commonProblem: '常见问题',
  aboutUs: '关于我们',
  findUs: '联络我们',
  loginAndRegistration1: '登录/注册',
  loginAndRegistration: '登录',
  // 底部信息
  filingNumber: '备案号码',
  YiliPublicWelfareFoundation: '亿利公益基金会',
  contactAddress: '联系地址',
  contactAddressDetaile: '香港湾仔港湾道18号中环广场60楼6005室',
  notice_info:
    '请注意：主办机构对此次比赛的规则和结果保留最终决定权，不作另行通知',
  contactUs: '联系我们',
  phone: '电话',
  socialMedia: '社交媒体',

  // 首页
  competitionSchedule: '大赛时间表',
  seeMore: '查看更多',
  previousCompetitions: '第一届库布其奖得奖名单',
  introductionToTheOrganizer: '主办机构',
  introductionToTheOrganizerDetail:
    '亿利公益基金是由亿利国际投资有限公司发起的公益慈善组织，专注于环境保护事业。该基金会致力于推动国际和国内生态治理和环保领域的新科技和新模式发展，特别是在“一带一路”国家的环境治理和可持续发展方面。',
  workName: '作品名称',
  and: '及',
  WinningTeam: '得奖队伍',
  Awarded: '获得奖项',
  CompetitionName: '比赛名称',
  OfficialEventManagementPartner: '大会活动管理合作伙伴',
  OfficialAdvisoryServicePartner: '大会咨询服务合作伙伴',
  OfficialSocialImpactPartner: '大会社会影响力合作伙伴',
  OfficialMentorshipPartner: '大会专家导师伙伴',
  contextDetaile: '比赛详情',
  CompetitionIntroduction: '大赛介绍',
  PleaseEnterContent: '请输入内容',
  submitComments: '提交评论',
  commentHistory: '评论记录',
  noComments: '暂无评论',

  // 首页-奖项
  awards: '奖项',
  associateHongKongGroup: '大学组',
  middleSchoolGroup: '中学组',
  middleSchoolGroup1: '中学组',
  universityInternationalGroup: '大学组',
  universityInternationalGroup1: '大学国际组',
  championTeam1: '冠军一队',
  championTeam11: '冠军一队',
  runnerUpTeam1: '亚军一队',
  runnerUpTeam11: '亚军一队',
  thirdPlaceTeam1: '季军一队',
  thirdPlaceTeam11: '季军一队',
  excellentAwardTeam7: '优秀奖十二队',
  excellentAwardTeam71: '优秀奖七队',
  DepartureFormHongKongSAR: '从香港特别行政区出发',

  bonus: '奖金',
  certificate: '奖状',
  andDesertFieldVisits: '奖状及沙漠实地考察',
  andDesertFieldVisitsHKcollege: '奖状',
  excellentAwardNTeam: '优秀奖N队',
  mostEnthusiasticParticipation: '优秀奖十二队',
  mostEnthusiasticParticipation1: '最踊跃参与学校奖一所(以参赛队伍数目计算)',
  fieldVisit: '*所有得奖计划书有机会应用于库布其沙漠及其他国家沙漠治理项目',
  signUpNow: '立即报名',
  RegistrationDetermined: '报名截止日期',
  SubmissionDetermined: '作品提交截止日期',
  sliderTitle: '扫码体验',
  sliderSubtitle: '库布其奖AR场景',
  RightOfInterpretation:
    '如任何组别最终提交参赛作品不足50份，主办方有权修改该组别赛制或取消该组别比赛。',
  mostActive: '最踊跃参与学校奖',
  mostActiveSchool: '迦密柏雨中学',

  //
  supportingEnterprises: '支持单位',
  // 库布其大赛报名
  registrationForTheKubuqiCompetition: '库布其大赛报名',
  teamInformation: '团队信息',
  TEAMNAME: '团队名称',
  fullName: '姓名',
  position: '职位',
  dateOfBirth: '出生日期',
  schoolName: '学校名称',
  studentID: '学生编号',
  Email: '电子邮箱',
  studentIDCard: '学生证',
  selectGroup: '请选择参赛组',
  confirmRegistration: '确认报名',
  registrationSuccessful: '报名成功！',
  registrationSuccessfulTips: '你会在稍后收到比赛报名成功确认电邮',
  pleaseContact: '如有任何查询，请联络',
  viewAuditProgress: '查看审核进度',
  noData: '暂无数据',

  // 最新资讯
  newsInformation: '最新消息、社交媒体贴文',
  pressRelease: '大赛新闻稿、有关大赛报道',
  contestAtlas: '大赛图集',
  currentPosition: '当前位置',
  informationDetails: '资讯详情',
  issueDetails: '问题详情',
  Comment: '发表评论',
  warnInfo6: '请输入要评论的内容！',
  warnInfo7: '评论成功',
  videoTitle1:
    '第二届库布其奖：大学宣讲会 香港教育大学：『全球暖化、气候变迁』环境、社会及管治(ESG)策略',
  videoTitle2:
    '第二届库布其奖：大学简介会 —— 香港恒生大学：『永续金融：商业领域的绿色发展』探索绿色经济全新职业道路',

  // 个人中心
  personalCenter: '个人中心',
  accountInformation: '账号信息',
  myRegistration: '我的报名',
  // contactUs: '联系我们',
  logOut: '退出登录',

  //个人中心-账号信息
  basicInformation: '基本资料',
  avatar: '头像',
  teamInformation: '团队资料',
  addMembers: '添加成员',
  save: '保存',
  teamName: '团队名称',
  delete: '删除',
  reset: '重置',
  edit: '编辑',
  modify: '修改',
  uploadCampusCard: '上传学生证',
  front: '正面',
  opposite: '反面',

  // 个人中心-我的报名
  registeredContest: '已报名大赛',
  theKubuqiCompetition: '库布其大赛',
  matchProgress: '比赛进度',
  registrationStatus: '报名状态',
  workStatus: '作品状态',
  pendingApproval: '待审批',
  passed: '已通过',
  fail: '未通过',
  WorkSubmissionTime: '作品提交时间',
  viewDetails: '查看详情',
  currentState: '当前状态',
  goToModifyInformation: '前往修改信息',
  return: '返回',
  clickToSubmit: '点击提交',
  modifyInformation: '请前往修改信息！',
  comingToAnEnd: '即将截至',
  copyEmailAddress: '复制电邮地址',
  registrationTeam: '报名队伍',
  competitionBrowsing: '大赛浏览',
  officialEmail: '大赛官方邮箱',
  workSubmit: '作品提交',
  tips: '提示：请上传作品附件，附件类型：视频、PDF、PPT',
  warnInfo: '提示：请上传作品附件（视频、PDF、PPT），文件大小不超过2GB。！',
  warnInfo1: '上传失败！',
  checkEntryStatementInfo: '请先勾选作品声明。',

  // 个人中心-作品状态
  notFiled: '未提交',
  submitted: '已提交',
  underReview: '评审中',
  beShortlistedSuccessfully: '入围成功',
  shortlistingFailure: '入围失败',
  clickToUpload: '点击上传',
  uploading: '正在上传',
  // cancellation: '取消',
  submitWorks: '提交作品',
  IAmAgree: '我已阅读、并同意',
  EntryStatement: '参赛作品声明',
  IntellectualProperty: '一、知识产权',
  IntellectualPropertyInfo:
    '参赛者须保证其参赛作品必须为原创及不会侵犯第三人的权利，包括知识产权、保密权或私隐权。对于参赛作品，参赛者须承担一切法律责任。',
  KnowledgeSharing: '二、知识共享',
  KnowledgeSharingInfo:
    '参赛者理解并同意，参赛作品的知识产权将用于教育、科学传播和生态环保等公益目的。亿利公益基金会和TREELION基金会创益基金会（以下简称“主办方”）主办方承诺在非商业用途下使用这些作品，以促进沙漠可持续发展和生态保护的理念。',
  LegalResponsibility: '三、法律责任',
  LegalResponsibilityInfo:
    '主办方将尽最大努力保护参赛作品的知识产权，但对可能发生的作品行为承担法律责任。如有争议，将依法解决相关法律法规。',
  CopyrightOwnership: '四、版权归属',
  CopyrightOwnershipInfo: '所有参赛作品一经提交，版权全部归主办方所有。',
  CopyrightUsage: '五、版权使用',
  CopyrightUsageInfo1:
    '1.知识产权使用权：参赛者特此同意，主办方拥有使用参赛作品的知识产权的权利，包括但不限于复制、传播、转发、展示、出版、修改等方式使用作品。方仅可在非商业下使用参赛作品，包括但不限于宣传、推广、广告以及任何与大赛相关的活动。',
  CopyrightUsageInfo2:
    '2. 作者署名权：放弃参赛者另外书面要求匿名，主办方将在任何使用参赛作品的场合下尽力署名作者。在任何情况下，署名将仅包括参赛者的姓名，不包括其他个人信息。主办方将尽力保护参赛者的隐私。',
  CopyrightUsageInfo3:
    '3. 宣传与推广：参赛者同意主办机构使用其姓名、相片及简报等作品进行宣传及推广之用。',
  CopyrightUsageInfo4:
    '4. 放弃权益：参赛者明确放弃对参赛作品的任何形式的经济权益或其他权益，除非有书面协议。',
  AttendanceOnJudgingDay: '六、出席比赛评审日',
  AttendanceOnJudgingDayInfo:
    '关于香港大学组，所有提交了计划书并成功进入决赛的参赛者，必须亲自出席决赛评审日 (香港组现场评审) 。',
  PrivacyStatement: '七、私隐条例',
  PrivacyStatementInfo:
    '参赛者同意并同意承办方收集个人资料，包括参赛者姓名、法国地址及联系电话，仅用于本比赛核对参赛者身份和联系方式而得奖者用途。主办方会于本比赛结果于三个月后公布内记参赛者提供的个人资料（于本比赛社交媒体及网站公布的资料时），主办方不得将个人资料转移给其他第三者（按法律或法例规定）。',
  AgreementEffectiveness: '八、协议生效',
  AgreementEffectivenessInfo:
    '参赛者提交参赛作品即表示同意本声明的所有条款和条件，并受其约束。',
  lastNoticeInfo:
    '*请注意：主办机构对本届比赛的结果规则并保留最终决定权，不作另行通知。如果您对以上声明的任何部分有疑问或需要进行特殊协商，请与主办方决定联系，以进一步明确您的要求权益和期望。',

  // 登录页面
  loginAccount: '登录账号',
  mailbox: '邮箱',
  pleaseEnterTheRegistrationEmail: '请输入注册邮箱',
  password: '密码',
  pleaseEnterYourLoginPassword: '请输入登录密码',
  code: '验证码',
  pleaseEnterTheVerificationCode: '请输入验证码',
  sendVerificationCodeToEmail: '发送验证码到邮箱',
  codeTime: '秒后重试',
  SendVerificationCode: '发送验证码',
  TheVerificationCodeHasBeenSent: '验证码已发送到邮箱，请注意查收',
  logInNow: '立即登录',
  noAccount: '没有账号？马上',
  register: '注册',
  warnInfo2: '请输入账号和密码！',
  warnInfo21: '登录成功！',

  // 注册页面
  accountRegistration: '账户注册',
  confirmPassword: '确认密码',
  pleaseReenterTheLoginPassword: '请再次输入登录密码',
  // fullName: "姓名",
  PleaseEnterTheTeamName: '请输入团队名称',
  // dateOfBirth: "出生日期",
  // schoolName: "学校名称",
  // studentID: "学生编号",
  registerNow: '立即注册',
  backLoginText: '返回登录',
  existingAccount: '已有账号？马上',
  login: '登录',
  warnInfo3: '确认密码与设置密码不一致!',
  warnInfo8: '请输入正确格式邮箱',
  warnInfo9: '验证码只有六位数哦',
  warnInfo10: '秒后重新发送',
  warnInfo11: '最少两名成员参赛',
  warnInfo16: '请上传学生证',
  warnInfo17: '队员信息请填写完整哦',
  warnInfo18: '最多只能有四名成员哦',
  warnInfo19: '队员信息请输入完整哟',
  warnInfo20: '最多只有四位成员哟',

  // 个人中心-账号信息
  accountEmail: '账号邮箱',
  captain: '队长',
  member: '队员',
  pleaseEnterTheCaptainName: '请输入队长姓名',
  pleaseEnterAMember: '请输入队员',
  PleaseEnterTheDateOfBirth: '请输入出生日期',
  PleaseEnterSelectBirthDay: '请选择出生日期',
  pleaseEnterTheSchoolName: '请输入学校名称',
  pleaseEnterTheStudentId: '请输入学生编号',
  pleaseEnterEmail: '请输入电子邮箱',
  pleaseEnterEmailInfo: '请输入邮箱',
  pleaseEnterYourName: '请输入姓名',
  pleaseUploadYourCampusCard: '请上传学生证',
  warnInfo4: '报名已截止！',
  warnInfo5: '退出成功！',
  warnInfo12: '修改成功',
  warnInfo13: '修改失败',
  warnInfo14: '请输入正确的队名',
  warnInfo15: '请上传图片',

  // 个人信息-修改个人信息-弹窗
  changePassword: '修改密码',
  enterOldPassword: '输入旧密码',
  pleaseEnterYourOldPassword: '请输入旧密码',
  enterANewPassword: '输入新密码',
  pleaseEnterANewPassword: '请输入新密码',
  confirmPasswordAgain: '再次输入密码',
  pleaseConfirmTheNewPassword: '请确认新密码',
  passwordInfo: '*密码长度至少16位，且包含大、小写字母及数字',
  cancellation: '取消',
  confirmModification: '确认修改',
  passwordWarnText: '密码长度至少6位',

  // 关于我们
  yiliPublicWelfareFoundation: '亿利公益基金会',
  yiliPublicWelfareFoundationInfo:
    '亿利公益基金是由亿利国际投资有限公司发起的公益慈善组织，专注于环境保护事业。该基金会致力于推动国际和国内生态治理和环保领域的新科技和新模式发展，特别是在“一带一路”国家的环境治理和可持续发展方面。',
  DesertificationEnvironmentDiffusion: '荒漠化环境扩散',
  PromoteEcologicalGovernanceEducation: '推动生态治理教育',
  InheritingGreenEnvironmental: '透过活动传承绿色环保',
  passActiveInfoOne: '第八届库布其国际沙漠论坛',
  passActiveInfoTwo: '香港绿色金融分论坛 2021',
  passActiveInfoThree:
    '亿利公益基金会亦于2021年9月28日与香港地球之友联合举办第八届库布其国际沙漠论坛的香港绿色金融分论坛。以「碳达峰.碳中和—共建人与自然生命共同体」为主题，邀请80多位绿色金融专家和专业人士。其中不乏香港及中国内地绿色金融行业的顶尖级专家学者及业界翘楚，包括香港绿色金融协会主席马骏教授、联合国副秘书长兼联合国环境署执行主任埃里克·索尔海姆先生、现任生态环境部宣传教育中心主任贾峰等。大家共聚一堂探讨香港作为国际金融中心，如何引导资本建设低碳经济以达至碳中和，提出不少关于香港绿色金融发展的宝贵意见和建议。',
  passActiveInfoFour:
    '亿利公益基金会相信绿色金融是缓解全球暖化的关键工具。这能令香港能够抓紧大湾区的机遇，到2050年实现碳中和，成为亚太地区的绿色金融中心。',

  treelionFoundation:
    '由亿利国际投资有限公司孵化的Treelion Foundation 于2019年在新加坡正式注册成立，是全球最大的绿色生态基金之一。基金会计划利用区块链技术，构建可持续发展和低碳绿色数字经济平台。',
  contactInformation: '联络方式',
  eleEmail: '电邮',
  DesertForumTitle: '第八届库布其国际沙漠论坛',
  The8thKubuqiInternationalDesertForumin2021: '第八届库布其国际沙漠论坛',
  HongKongGreenFinanceSubForumTitle: '香港绿色金融分论坛 2021',
  DesertForumInfo: `<p>亿利公益基金会亦于2021年9月28日与香港地球之友联合举办第八届库布其国际沙漠论坛的香港绿色金融分论坛。以「碳达峰.碳中和—共建人与自然生命共同体」为主题，邀请80多位绿色金融专家和专业人士。其中不乏香港及中国内地绿色金融行业的顶尖级专家学者及业界翘楚，包括香港绿色金融协会主席马骏教授、联合国副秘书长兼联合国环境署执行主任埃里克·索尔海姆先生、现任生态环境部宣传教育中心主任贾峰等。大家共聚一堂探讨香港作为国际金融中心，如何引导资本建设低碳经济以达至碳中和，提出不少关于香港绿色金融发展的宝贵意见和建议。</p><p>亿利公益基金会相信绿色金融是缓解全球暖化的关键工具。这能令香港能够抓紧大湾区的机遇，到2050年实现碳中和，成为亚太地区的绿色金融中心。</p>`,
  briefItemInfo1:
    '以荒漠化防控和生态保护为切入点，重点聚焦解决土地、大气、土、水和生物污染治理问题，推动全球生态文明建设',
  briefItemInfo2:
    '重新定义绿色资产、打造生态、金融与互联网相结合的可持续发展的绿色商业模式，致力创建全球最大的绿色数字资产生态系统',
  briefItemInfo3:
    '利用区块链的分布式、不可篡改和协同共识特性，记录全球环境及生物多样性数据，构建全球生态大数据平台',
  briefItemInfo4:
    '在全球范围内推动国际、地区、国家和地方等多层次的广泛的绿色合作、实现生态文明共建、共享、共赢的发展机会',
  CochairsoftheGlobalSteeringCommittee: '全球指导委员会联席主席',
  GlobalEnvironmentalandDevelopmentLeaders: '全球环境与发展领袖',
  FormerDeputySecretaryGeneraloftheUnitedNations: '前联合国副秘书长',
  FormerExecutiveDirectorofUNEP: '环境规划署前执行主任',
  FormerNorwayMinisterofEnvironmentandInternationalDevelopment:
    '前挪威环境和国际发展部部长',
  FormerExecutiveDirectoroftheUnitedNationsEnvironmentProgramme:
    '前联合国环境署执行主任',
  ChiefExecutiveOfficerandDirectors: '首席执行官及董事',
  ChairmanoftheBoardofDirectorsofFriends: '地球之友（香港）董事会主席',
  MemberoftheInvestmentCommitteeInfo1: '香港特区政府奖学基金投资委员会 委员',
  MemberoftheInvestmentCommitteeInfo2:
    '香港特区政府自资专上教育基金投资委员会 委员',
  InvestmentCommitteeoftheHKSARGovernmentScholarshipFund:
    '香港特别行政区政府奖学基金投资委员会',
  MemberofSelffinancingPostsecondaryEducationFundInvestmentCommitteeoftheHKSARGovernment:
    '香港特别行政区政府自负盈亏专上教育基金投资委员会委员',
  MrErikSolheim: '埃里克·索尔海姆先生',
  MrPlatoKTYip: '叶广涛先生',

  // 历届比赛花絮
  previousShortFilms: '往届比赛介绍短片',
  previousShortFilmsTips: '第一届比赛视频宣传片',
  previousPhotos: '往届比赛照片',
  previousVisits: '往届比赛访问',
  previousVisitsName1: '从想象中的荒漠到眼前的绿洲——香江学子的库布其之行',

  // 大赛背景
  countdown: '库布其大赛 报名截止日倒计时',
  deadline: '比赛截至报名日期',
  dateOfPublication: '赛果公布日期',
  year: '年',
  month: '月',
  sun: '日',
  day: '天',
  KBQbackgroundOfTheCompetition: '库布其模式',
  KBQbackgroundOfTheCompetitionInfo: `<p> 由于全球气候环境变化，全球超过<span class="highlight">2.5亿</span>人受到土地荒漠化的直接影响，约有<span
  class="highlight">10亿</span>人生存情况因此岌岌可危。全球约<span class="highlight">20亿</span>人依赖于干旱地区的生态系统，其中<span
  class="highlight">90%</span>生活在发展中国家，“一带一路”国家正是荒漠化严重的主要区域之一。
</p>
<p>
库布其沙漠是<span class="highlight">中国第七大</span>的沙漠，位于内蒙古鄂尔多斯，总面积为<span
  class="highlight">1.86万</span>平方公里，是距离北京最近的沙漠。库布其沙漠在清朝时期早先是一片草原，但由于过度放牧等多种原因，在清末逐渐荒漠化，曾被称为「死亡之海」。经过近<span
  class="highlight">30年</span>的艰辛治沙，今天的库布其沙漠已变回绿洲。已有三分之一的沙漠面积得到修复，土地重新蓬勃发展，生物种类达到了530种。恢复经济活动使得<span
  class="highlight">10多万</span>牧民脱贫，<span class="highlight">30年</span>的治理创造了联合国推崇的"库布其模式"。
</p>`,
  KBQawards: `<p>本届<span class="highlight">「库布其奖」：国际沙漠可持续发展大赛</span>及<span class="highlight">「谈谈可持续」中学生短片比赛</span>旨在鼓励香港乃至国际年轻人关注<span class="highlight">全球气候环境议题</span>、思考<span class="highlight">全球和国家的沙漠治理及可持续发展</span>，并同时发掘国际优秀及有潜质的人才，为生态环保和新型可持续发展领域培养未来的行业领袖，不仅对国内，甚至对于「一带一路」的环境治理模式提供积极贡献。</p>
  </br><p>比赛让大专及大学生开拓思路，提出创新且可行的沙漠可持续发展方案，以推动解决当前土地荒漠化问题，响应全球碳中和政策目标，并为生态环保和新型可持续发展领域培养未来的行业领袖。同时，让中学生通过拍摄短片了解可持续发展对于生态脆弱地区的重要作用。</p>`,
  target: '联合国可持续发展目标',
  targetInterpretation:
    '库布其大赛全力推动联合国的17项可持续发展目标（SDGs），特别聚焦于目标4（教育）、目标13（气候行动）以及目标17（合作实现目标）。此次大赛主题聚焦于沙漠可持续发展，并充分考虑现今以及未来两个发展时间轴。学生参赛作品将有机会涵盖更多的目标，借此进一步促进这些目标的实现。',
  targetInterpretation1: `SDGs建基于可持续发展的三大基石：经济增长、环境保护及社会进步，期望在促进经济发展的同时，亦能保护地球环境及减少不平等，让世界变得更繁荣、健康、包容，与可持续。响应联合国所订立的目标，为建立可持续发展的社会群策群力。了解更多关于联合国的17项可持续发展目标及详细准则，可参阅<a href="https://sdgs.un.org/zh" target="_blank" rel="noopener noreferrer">SDG官網</a>。`,
  contestTheme: '大赛组别',
  topicIntroduction: '主题介绍',
  contestMode: '大赛模式',
  YouthSustainableDevelopmentEducation: '青少年可持续发展教育',
  YouthInfoOne: '确保香港学生获得促进可持续发展和环境保护所需的知识和技能',
  YouthInfoTwo: '鼓励跨学科批判性思维、问题解决和知识的实际应用',
  YouthInfoThree:
    '促进全球公民意识和对文化多样性以及文化对可持续发展的贡献的欣赏',
  YouthInfoFour: '培养未来环境保护和可持续发展的领导者',
  YouthInfofive:
    '促进全球公民意识和对文化多样性以及文化对可持续发展的贡献的认识',
  ClimateEducationTheme: '气候教育主题',
  ImprovingEducation: '提高减缓气候变化的教育、意识和能力',
  ImprovingEducationInfoOne: '提高人们对采取气候行动重要性的认识',
  ImprovingEducationInfoTwo: '激发年轻一代对环保的兴趣',
  PartnershipAchieveGoals: '实现目标的伙伴关系',
  PartnershipAchieveGoalsInfo:
    '通过寻求赞助和合作来支持库布其奖倡议和防治荒漠化，调动资源，在可持续发展方面发挥更大影响',
  // 大赛主题
  topicIntroductionText:
    '为鼓励香港以至国际年轻人关注全球气候环境议题、思考全球和国家的沙漠治理及可持续发展，第二届“库布其奖“：「谈谈可持续」中学生短片比赛让香港中学生通过拍摄短片了解可持续发展对于生态脆弱地区的重要作用，提升公众对全球气候环境议题的关注，响应全球可持续发展目标。',
  topicIntroductionCollegeText:
    '为鼓励香港以至国际年轻人关注全球气候环境议题、思考全球和国家的沙漠治理及可持续发展，第二届“库布其奖“：国际沙漠可持续发展大赛将面向全港大学及大专生，让学生开拓思路，展现对国际前沿技术的认知及可持续方案的构想，提出创新且可行的沙漠可持续发展方案，以推动解决当前土地荒漠化问题，回应全球碳中和政策目标。',

  // --中学组
  MStopicListText: '学生需制作一条环境可持续宣传短片，内容须包含其中一项主题：',
  MStopicitem1: '能源与气候变化',
  MStopicitem2: '大气污染与空气质量',
  MStopicitem3: '水资源与保护',
  MStopicitem4: '生物多样性与自然保护',
  // --大专组及大学组
  JCtopicListText: '参赛计划书可根据一下四个主题其中一个：',
  JCtopicitem1: '沙漠零碳新城设计+计划书',
  JCtopicitem1Info:
    '如何利用现代化科技手段和先进的建筑设计理念，实现沙漠城市节能减排、沙漠资源高效利用，同时创造人性化、健康、舒适的居住环境，提升城市生态价值和人居质量？',
  JCtopicitem2: '沙漠生态旅游商业计划书',
  JCtopicitem2Info:
    '如何利用沙漠资源和文化为游客提供沙漠地区独特的旅游体验，同时保护沙漠生态环境和提升当地小区的经济发展，振兴沙漠旅游业？',
  JCtopicitem3: '沙漠能源及水资源可持续利用计划书',
  JCtopicitem3Info:
    '如何利用太阳能和风能等可再生能源，以及如何收集、存储和利用雨水和地下水等水资源，以提高沙漠地区的生产力和经济发展？',
  JCtopicitem4: '沙漠生态系统保护和恢复计划书',
  JCtopicitem4Info:
    '如何保护生态脆弱的沙漠中的植被和野生动物，建立沙漠保护区和恢复生态系统的项目，以及推广可持续的土地管理和农业实践等？',

  // 大赛模式
  // 中学
  JCcontestModeitem1: '比赛地点',
  JCcontestModeitemInfo: '香港（线上）',
  JCcontestModeitem2: '参赛对象',
  JCcontestModeitem2Info: '香港在在读中学生',
  JCcontestModeitem3: '组队形式',
  JCcontestModeitem3Info: `<p>可校内自行组队，每队由2-4名成员组成</p><p>每队需由一位学校老师提名，每所学校可多于一队参赛</p>`,
  // "2-4人一组，可自行组队参赛，成员可来自不同学校、不同年级",
  JCcontestModeitem4: '作品形式',
  JCcontestModeitem4Info: '1.5分钟影片；以MP4格式上传',
  JCcontestModeitem5: '作品语言',
  JCcontestModeitem5Info:
    '参赛者上传初赛作品后，将由评审进行在线评审。决赛入围作品中的15个队伍将被上传至大赛官网，并接受公众点赞。最终总分将由评审团评分和公众评分的总和确定。',
  JCcontestModeitem6: '比赛形式',
  JCcontestModeitem6Info:
    '参赛者提交短片后，由评审团评分及选出15份决赛作品，加上公众投票得出最终结果。',

  // 大专
  // JCcontestModeitem1: '比赛地点',
  JCcontestModeitem1Info: '香港（线上及线下）',
  JCcontestModeitem2: '参赛对象',
  JCcontestModeitem21Info:
    '香港所有大学及大专在读生 (包括资助大学、自资院校、专上学院、私立大学等) ',
  JCcontestModeitem31: '组队形式',
  JCcontestModeitem31Info:
    '可自行组队参赛，每队为2-4名成员，成员可来自不同院校、学段及学系',
  JCcontestModeitem41: '作品形式',
  JCcontestModeitem41Info: '计划书，以pdf格式提交',
  JCcontestModeitem5: '作品语言',
  // JCcontestModeitem5: "比赛形式",
  JCcontestModeitem5Info: '粤语、英语、普通话',
  // JCcontestModeitem6: '参赛数目上限',
  JCcontestModeitem61: '作品规格',
  // JCcontestModeitem6Info: '中文3000字内；英文3500内',
  JCcontestModeitem61Info: `<p>初赛作品：2页起，包含文字/设计图/表格；有效表达计划概念；</p><p>决赛作品：大概5页，包含完整落实计划书、财政测算、设计（可选）</p>`,
  JCcontestModeitem7: '比赛形式',
  JCcontestModeitem7Info: `<p>参赛者上传初赛作品后，评审将进行在线评审，并选出决赛队伍；</p><p>入围决赛的队伍将接受专家培训，并修改、细化作品；</p><p>提交最终作品后，队伍将参加线下作品展示及答辩，评审团将现场评分；</p><p>优胜队伍将于颁奖典礼前公布。</p>`,
  // JCcontestModeitem7Info:
  //   "参赛者上载初赛作品后，评审将进行在线评审。决赛入围队伍有机会修改作品，并参加线下展示及答辩。评审团将现场评分，选出优胜队伍。",
  JCcontestModeitem8: '参赛数目上限',
  JCcontestModeitem8Info: '不限',
  // JCcontestModeitem8Info: `<p>参赛者上传初赛作品后，评审将进行在线评审，并选出决赛队伍；</p><p>入围决赛的队伍将接受专家培训，并修改、细化作品；
  // </p><p>提交最终作品后，队伍将参加线下作品展示及答辩，评审团将现场评分；</p><p>优胜队伍将于颁奖典礼前公布。</p>`,
  JCcontestModeitem9: '字数限制',
  JCcontestModeitem9Info: '中文3000字内；英文3500字内',

  // 大学国际组
  // UcontestModeitem1: '比赛地点',
  judgeDay: '评审日',
  judgeDayInfo: `
  <p>-地点：香港中环红棉路8号东昌大厦</p>
  <p>-日期：2024年4月11日</p>
  <p>-時間：TBC</p>`,
  UcontestModeitem1Info: '全球（线上）',
  UcontestModeitem2: '参赛对象',
  UcontestModeitem2Info: '全球所有大学就读全日制大学生及研究生',
  UcontestModeitem3: '组队形式',
  UcontestModeitem3Info:
    '可自行组队参赛，每队为 2-4 名成员，成员可来自不同院校、学段及学系',
  UcontestModeitem4: '作品形式',
  UcontestModeitem4Info: '计划书，以pdf格式提交',
  UcontestModeitem5: '参赛名额',
  UcontestModeitem5Info: '粤语、英语、国语',
  UcontestModeitem6: '作品规格',
  UcontestModeitem6Info: `
  <p>初赛作品：2页起，包含文字/设计图/表格；有效表达计划概念</p>
  <p>決赛作品：参赛队伍需递交商业计划书及汇报用简报（于评审日汇报中使用）</p>
  <p>1.商业计划书：  </p>
  <p>&emsp;-格式要求：PDF档案，需包括完整商业计划、财务测算、技术设计（可选）页数不限  </p>
  <p>&emsp;-字数限制：中文不少于2,000字，英文不少于2,500字</p>
  <p>&emsp;-最后递交日期：2024年4月2日23:59</p>
  <p>&emsp;-商业计划书一但递交则不可以更改；如没有准时递交简报的队伍将被取消比赛资格  </p>
  <p>2.汇报简报：</p>
  <p>&emsp;-格式要求：PPT档案，不少于5页</p>
  <p>&emsp;-最后递交日期：2024年4月7日23:59</p>
  <p>&emsp;-简报一但递交则不可以更改；如没有准时递交简报的队伍将被取消比赛资格  </p>
  <p>&emsp;-评审日当天主办方会将队伍递交的简报准备在汇报屏幕上，同时队伍亦请自行准备备用简报以备不时之需</p>`,
  UcontestModeitem7Info: `
  <p>参赛者上传初赛作品后，评审将进行在线评审，并选出决赛队伍；</p>
  <p>入围决赛的队伍将接受专家培训，并修改、细化作品；</p>
  <p>提交最终作品后，队伍将参加在线作品展示及答辩，评审团将现场评分；</p>
  <p>优胜队伍将于颁奖典礼前公布；</p>
  <p>队伍需在汇报时间前10分钟到达会场报到，如汇报前10分钟不够半数队员到达会场报到，队伍将被取消资格；</p>
  <p>汇报时间15分钟；</p>
  <p>汇报后进行问答环节，由评审向队伍发问问题，限时5分钟；</p>
  <p>决赛结果会在4月20日公布；</p>
  `,
  judgCriteria: '评审标准',
  judgCriteriaInfo: `
  <p>满分100分，商业计划书占总评分的75%，现场汇报评分占比25%。</p>
  <p>1.商业计划书（75%）：环境保护性（25%）、创新及原创性（25%）、效益及可行性（25%）</p>
  <p>2.评审日汇报（25%）：以演讲者现场汇报表现评分，包括汇报技巧（5%）、PPT展示效果（5%）、问答环节应答表现（5%）、队员出席率（5%）、汇报用时情况（5%）</p>
  <p>评审员会对所有决赛队伍根据上述标准进行评分，分数最高的三队将成为比赛的冠亚季军。</p>`,
  UcontestModeitem8Info: `限500组（依报名次序进行登记）`,

  // 往届参赛列表
  talkAboutDesertificationShortFilmCompetition: '「说说荒漠化」短片比赛',
  publicToLikeAwards: '公众至Like大奖',
  desertGovernanceEntrepreneurshipCompetition: '荒漠治理创业大赛',
  christianAndMissionaryAllianceSunKeiSecondarySchool: '基督教宣道会宣基中学',
  surprisinglyDesolate: '惊「荒」',
  CCCFongYunWahSecondarySchool: '中华基督教会方润华中学',
  TheMindOftheSandElf: '沙精灵的心事',
  MingChiCollegeOftheChineseChristianChurch: '中华基督教会铭基书院',
  unbalance: '失衡',
  HumanitySinicization: '人类与荒汉化',
  CheungChukShanCollege: '张祝珊英文中学',
  LEGOCityDesolationAndLocalization: '乐高城市荒汉化',
  DesolateLandAndFragrantLand: '荒洲 · 芳洲',
  MissionaryAssociationChenZhuSuhuaMemorialHighSchool: '宣道会陈朱素华纪念中学',
  Youthtroubles: '少年的烦恼',
  DiocesanGirlsSchool: '拔萃女书院',
  WildernessHair: '荒 · 发',
  ELCHKLutheranSecondarySchool: '基督教香港信义会信义中学',
  DesertificationIssues: '荒漠化问题',
  HongKongRedSwastikaSocietyTaiPoSwastikaSecondarySchool:
    '香港红卍字会大埔卍慈中学',
  TwoMinutesToUnderstandTheChineseCultureOfTheWilderness: '两分钟了解荒汉化',
  HongKongFabricManufacturersAssociationZhuShilinSecondarySchool:
    '香港布厂商会朱石麟中学',
  HowSeriousIsDesertification: '荒漠化有多严重?',
  LaSalleCollege: '喇沙书院',
  DesertEncyclopedia: '荒漠小百科',
  champion: '冠军',
  TopTwentyFinalists: '20 强入围',
  otherWorks: '其他作品',
  MunsangCollegeHongKongIsland: '港岛民生书院',
  TheCulpritOfDesertification: '荒漠化元凶',
  PoLeungKukRocheFoundationMiddleSchool: '保良局罗氏基金中学',
  WhenTheEarthEncountersDesertification: '当地球遇上荒漠化',
  EpiscopalLamChoMouSecondarySchool: '圣公会林裘谋中学',
  GlobalWildernessGettoKnowIt: '全球荒汉化·带你认识它',
  EpiscopalWhiteJohnChurchHighSchool: '圣公会白约翰会督中学',
  EarthPartyTalkingAboutWasteCake: '地球派对-说荒蛋糕',
  runnerUp: '亚军',
  TrueLightGirlsCollege: '真光女书院',
  DoNotWasteZhang: '请勿「荒」张',
  TungWahGroupOfHospitalsKapYanDirectorsCollege: '东华三院甲寅年总理中学',
  CryingEarth: '哭不出的地球',
  TungWahGroupOfHospitalsQiuZitianMemorialMiddleSchool:
    '东华三院邱子田纪念中学',
  TheStrangeSoldierOfWildernessAndBirthday: '「荒·诞」奇兵',
  ThirdPlaceRunnerUp: '季军',
  EnpingChamberofCommerceandIndustryLiLinmingMiddleSchool:
    '恩平工商会李琳明中学',
  EsportsSandPreventionStrategy: '电竞防沙攻略',
  ActivelyParticipatingInSchoolAwards: '最踊跃参与学校大奖',
  CONSTRUCTINGOUTDESERTOPIAKUBUQI:
    'CONSTRUCTING OUR DESERTOPIA | KUBUQI联彼朔方',
  HongKongUniversityOfScienceAndTechnology: '香港科技大学',
  UtilizinggeneticallyengineeredmicrobialcocktailstotackledesertificationintheKubuqidesert:
    '利用基因工程微生物混合物治理库布其沙漠荒漠化',
  OtherWorks: '其他作品',
  CityUniversityOfHongKong: '香港城市大学',
  IoTKubuqiAnEcommercePlatformBringingTheWorldCloserToKubuqi:
    '物联库布齐——一个电商平台让世界走近库布齐',
  HongKongBaptistUniversity: '香港浸会大学',
  TheKubuqiAwardDesertificationControlBusinessPlanCompetition:
    '库布其奖荒漠化治理商业计划竞赛',
  Universities: '香港教育大学、香港中文大学、香港城市大学、香港大学',
  TheArtCapitalofKubuqi: '库布其艺术之都',
  TheChineseUniversityofHongKong: '香港中文大学',
  KubuqiEnvironmentalProtectionTown: '库布其环保市镇',
  CityUniversities: '香港城市大学、香港中文大学、香港大学',
  TheKubuqiAwardDesertificationControlBusinessPlan:
    '库布其奖-荒漠化控制商业计划',
  TheUniversityofHongKong: '香港大学',
  MemoryForest: '回忆森林 Memory Forest',
  LingnanSchoolinHongKong: '香港岭南⼤学',
  DesertificationDesertControlLaw: '荒漠化-荒漠治理⽅法',
  UniversitiesThree: '香港中文大学、香港大学、香港科技大学',
  KubuqiDesertControlBusinessPlanAquaponics:
    '库布其荒漠治理商业计划书-鱼菜共生',
  KubuqiDesertProvidingYouWithAnInternationalAcademicExchangePlatformforEcologicalEnvironment:
    '库布其沙漠 —— 提供你一个生态环境的国际学术交流平台',
  UniversitiesFour: '香港中文大学、香港大学',
  EcoSenseTianyouHeyi: 'EcoSense 天游合一',
  schoolInfoOne: '香港大学、香港理工大学、香港高等教育科技学院',
  schoolInfoTwo: '香港大学、香港浸会大学',
  workName1: '骆也融融',

  // 首页-大赛时间表
  MiddleSchoolGroupCompetitionProcess: '中学组竞赛流程',
  UniversityGroupCompetitionProcess: '大学组比赛流程',

  // 上传提示
  uploadTypeTips: '上传文件只能是 PDF、PPT、MP4 格式!',

  // 第二届库布其 短片投票
  secondTitle: '第二届库布其大赛',
  workDetail: '作品详情',
  vote: '立即投票',
  voted: '已投票',
  share: '分享',
  votingTime: '投票时间：',
  hintTimeError: '请在规定时间投票',
  copyUrl: '复制链接',
  saveQRCode: '存至本地',
  judgesNameOne: '戴沛权教授',
  judgesNameOneP1: '香港中文大学理学院地球与环境科学课程副教授',
  judgesNameOneP2: '香港中文大学理学院地球系统科学课程主任',
  judgesNameOneP3: '香港中文大学大学通识教育部副主任',
  judgesNameOneP4: '香港中文大学环境、能源及可持续发展研究所副所长',
  judgesNameTwo: '罗敏仪博士',
  judgesNameTwoP1: '自然在地创办人',
  judgesNameThree: '魏远强先生',
  judgesNameThreeP1: '香港教育城行政总监',
  judgesNameFour: '江培强博士',
  judgesNameFourP1:
    '香港理工大学设计学院多媒体科艺理学硕士副课程主任及助理教授',
  judgesNameFive: '郑启明先生',
  judgesNameFiveP1: '前香港电台一台台长',
  judgesNameSix: '卢永强先生',
  judgesNameSixP1: 'LOMATTERS 创作总监',
  judgesNameSixP2: '绿惜地球副主席',
  judgesNameSixP3: '香港设计中心董事',

  // 补充
  copyText: '链接已复制',
  voteSuccess: '投票成功',
  reTryInfo: '已发送验证码，请稍后重试',
  votedInfo: '您已经投过票了哦',
  voteText: '票',

  // 大学组10强
  universityTopTitle: '国际沙漠可持续发展大赛10强',
  universityTopText:
    '万众期待的国际沙漠可持续发展大赛10强名单出炉🎉！ 温馨提醒10强队伍需完成包括导师日、导师二次线上指导、提交最终作品及出席最终评审日的现场评审，以保留资格。 大赛筹委有权保留最终决定权，包括随时更改或取消参赛队伍资格。 感谢所有参赛队伍的参与，带来精彩的作品，令比赛生色不少💚！另外恭喜10强队伍🥳，稍后将会公布专家培训计划🧑🏻‍💻，大家记得持续关注@thekubuqiaward，取得更多比赛资讯💪🏻！',
  finalistsTitle: '10强名单（排名不分先后）︰',
  talks:
    '#库布其奖 #ESG #可持续发展 #环保 #社会 #企业 #投资 #香港 #沙漠 #库布其沙漠 #大专院校 #大学 #中学 #学生 #比赛',
  //
  placeholder1: '请输入作品名称',
  placeholder2: '请选择报名主题',
  notice: '*注意：上传附件类型为：视频、PDF、PPT；文件大小不超过2G',
  notice1: '点击上传作品附件',
  registrationTopic: '报名主题',
  uploaWork: '上传作品附件',
  theme1: '沙漠零碳新城设计计划书',
  theme2: '沙漠生态旅游商业计划书',
  theme3: '沙漠能源及水资源可持续利用计划书',
  theme4: '沙漠生态系统保护和恢复计划书',

  // 第一届比赛花絮
  AwardWinnersList: '中学组获奖名单',
  workList: '第一届库布其大赛-得奖作品',
  collegeContest: '大学生 - 荒漠化治理创业大赛',
  middleContest: '中学生 - 「说说荒漠化」短片比赛',
  workPriceList: '「谈谈可持续」中学生短片比赛得奖名单',
  workPriceList1: '国际沙漠可持续发展大赛得奖名单',
  side1: '大赛简介',
  side2: '师友计划',
  side3: '颁奖典礼',
  side4: '库布其沙漠之旅',
  side5: '赛后聚会',
  side6: '作品集',
  side7: '更多照片',

  brief1:
    '三场简介会于大赛截止报名前举行，同学们踊跃参与，现场气氛热烈。 宣讲会有幸邀请港龙航空行政总裁丘应桦先生以及亿利公益基金董事叶广涛先生，分别向同学分享撰写计画书的要诀以及解答同学对比赛的疑问。',
  brief2:
    '经过初赛的激烈竞争，14支优秀队伍成功晋级至决赛阶段，更获得金融行业专家亲身指导的难得机会。 </br><div>大赛主办方特邀巴克莱银行 (Barclays Bank PLC.)专家担任学生们的导师，针对商业计划书中的财务预算部分提供专业意见和建议。 专家导师的协助明显地提升了所有参赛提案的质量和内容的充实程度。</div>',
  brief3:
    '首届库布其大奖颁奖典礼由前教育局副局长蔡若莲博士担任主礼嘉宾。中联办教育科技部前部长李鲁及中联办教育科技部部长蒋建湘更莅临，亲身鼓励年轻一代在科学和环境领域不断努力探索，为地区以致全球环境保护做出积极贡献。',
  brief4:
    '获胜队伍赴库布其沙漠实地考察。 </br>- 参观库布其生态能源光伏项目 </br> - 参观高科技种子银行和种苗温室</br> -考察亿利东方学校</br> - 到牧民家里体验当地美食和民俗文化 </br>- 观看微创气流法植树和无人机植树演示</br> - 亲手种下树苗',
  brief5:
    '大赛圆满结束后，学生们化敌为友，应邀参加了主办方组织的赛后聚餐。他们在聚餐中互相交谈，分享比赛心得，并提供对下一届比赛有益的建议。同时，他们亦承诺愿意随时透过分享他们在大赛中所学到的宝贵经验和知识，为未来的师弟妹们提供帮助和支持。这种薪火相传氛围使得大赛的意义更加深远。不但能够让学生们不仅在专业上有所成长，同时亦培养了团队精神和友谊。',
  timeline: [
    {
      title: '2023/08/15—2023/10/31',
      content: '线上比赛报名'
    },
    {
      title: '2023/08/15—2023/11/05',
      content: '资格审查'
    },
    {
      title: '2023/11/01—2023/12/01',
      content: '提交影片作品'
    },
    {
      title: '2023/11/05—2023/12/05',
      content: '作品首阶段筛选'
    },
    {
      title: '2023/12/05—2024/02/01',
      content: '评审评分'
    },
    {
      title: '2024/02/01',
      content: '公布决赛前15名'
    },
    {
      title: '2024/02/01—2024/03/01',
      content: '民众投票'
    },
    {
      title: '2024/04/01',
      content: '公布得奖者'
    },
    {
      title: '待定',
      content: '颁奖典礼'
    },
    {
      title: '六月下旬',
      content: '库布其考察'
    }
  ],
  UniversityTimeline: [
    { time: '2023/10/03-2023/10/13', name: '大学宣讲会' },
    { time: '2023/08/15-TBC', name: '比赛网上申请' },
    { time: '2023/08/15-TBC', name: '资格检查' },
    { time: '2023/11/20-2023/12/31', name: '初赛作品提交' },
    { time: '2023/11/20-2024/01/05', name: '首阶段筛选' },
    { time: '2024/01/05-2024/02/08', name: '评审评分' },
    { time: '2024/02/09', name: '公告10名决赛入围者' },
    { time: '2024/02/20-2024/03/28', name: '专家培训' },
    { time: '2024/04/02', name: '最终作品提交' },
    { time: '2024/04/06-2024/04/13', name: '大学组评审日' },
    { time: '2024/04/20', name: '公布得奖者' },
    { time: '待定', name: '颁奖典礼' },
    { time: '六月下旬', name: '库布其考察' }
  ],
  judgesMiddlleSchoolContent: '中学组评委',
  judgesUniversityContent: '大学组评委',
  judgesDetailText: '详情',

  winnerTitle1: '地球护卫队 Earth Guardians',
  winnerMenber1: '队员：邱紫菁、陈艾青、王舒曼、刘美仪',
  winnerSchool1: '学校：风采中学',

  winnerTitle2: '碳世界',
  winnerMenber2: '队员：罗锐滨、熊文怡、马欣琳、杨琇巧',
  winnerSchool2: '学校：中华基督教会基元中学',

  winnerTitle3: 'TOAD Sustainable',
  winnerMenber3: '队员：罗慧婷、蔡灏宏、Sahin Daphne Eylul、粱雅怡',
  winnerSchool3: '学校：林大辉中学',

  workWinnerText1: '冠军作品：《能源及气候异常》',
  workWinnerText2: '亚军作品：《The Earth is so Sick》',
  workWinnerText:
    '季军作品 ：《为何地球水资源一再受污染？人类到底要如何生存！？地球护卫队多次强烈声明：水！请保护！》',

  outstandingText: '优异',

  universityTitle1: '沙漠王子',
  universityMenber1: '队员：杨茜、王艺桦',
  universityTitle2: '库布「奇」游',
  universityMenber2: '隊員：何希琳、楊曉鈴、何浩璋',
  universityTitle3: 'Stan',
  universityMenber3: '队员：廖若鹏、翁明明、陈靖岚、谭柏立',

  pastGamesTitle1: '《利用基因工程微生物混合物治理库布其沙漠荒漠化》',
  pastGamesMenber1: '队员：Keira Lee Rice、Agnieszka Monika Lesniak',
  pastGamesSchool1: '学校：香港科技大学',
  pastGamesTitle2: '《联彼朔方》',
  pastGamesMenber2: '队员：翁梓贤、袁映晴、李嘉敏、张晓婷',
  pastGamesSchool2: '学校：香港大学、香港理工大学、香港高等教育科技学院',
  pastGamesTitle3: '《骆也融融》',
  pastGamesMenber3: '队员：周晞晴、黄灏森、史胜义、薛煦祺',
  pastGamesSchool3: '学校：香港大学、香港浸会大学',

  pastGamesWorkTitle1: '冠军作品：《荒漠化元凶》',
  pastGamesWorkSchool1: '学校：港岛民生书院',
  pastGamesWorkMenber1: '队员：洪嘉轩、林敬贤、苏镜涛、叶家宝',
  pastGamesWorkTitle2: '亚军作品：《请勿「荒」张》',
  pastGamesWorkSchool2: '学校：真光女书院',
  pastGamesWorkMenber2: '队员：张颖岚、张旭悦、黄九双、梁嘉慧',
  pastGamesWorkTitle3: '季军作品 ：《电竞防沙攻略》',
  pastGamesWorkSchool3: '学校：恩平工商会李琳明中学',
  pastGamesWorkMenber3: '队员：莫俊宏、李浩贤',
  pastGamesWorkTitle4: '公眾至Like大奖作品：《荒》',
  pastGamesWorkSchool4: '学校：基督教宣道会宣基中学',
  pastGamesWorkMenber4: '队员：蒋卓姿、萧羡憧、杨萃心、王胤稀',

  timeLineTest: '时间轴',

  okText: '确认',

  interestingSidelightsTitle: '库布其大赛花絮',
  periodTitle: '第二届',
  interestingSidelightsContent:
    '首届库布其大奖颁奖典礼由前教育局副局长蔡若莲博士担任主礼嘉宾。中联办教育科技部前部长李鲁及中联办教育科技部部长蒋建湘更莅临，亲身鼓励年轻一代在科学和环境领域不断努力探索，为地区以致全球环境保护做出积极贡献。',
  interSide1: '大学宣讲会',
  interSide2: '导师日',
  interSide3: '终审日',
  interSide4: '颁奖典礼',
  interSide5: '库布其沙漠之旅',
  interSide6: '得奖作品',
  teachInText: `<span class="text_15"
              >&nbsp;&nbsp;&nbsp;&nbsp;本次大赛走进香港中文大学、香港科技大学、香港教育大学、香港岭南大学、香港恒生大学、香港城市大学、香港专业教育学院（沙田）及香港理工大学等高校，围绕气候变化和生态环境持续恶化等现状展开系列宣讲。主办方携手环境科学、可持续发展等领域的专家学者，以跨学科视角剖析全球气候变暖的严峻挑战与生态恶化的深层影响。嘉宾们立足自身研究，通过前沿数据、区域性案例及创新解决方案，生动阐释了碳中和路径、生物多样性保护、低碳城市建设等议题，并结合香港本土生态政策与学生展开深度对话。</span
            >
            <p></p>
            <span class="text_16"
              >&nbsp;&nbsp;宣讲会特设互动环节，鼓励学生就“个人行动与全球责任”提出见解，现场讨论热烈。活动以多元视角打破思维边界，不仅深化了青年学子对环境议题的认知，更激发了其投身可持续发展的使命感，为后续环节奠定了扎实的思想基础。</span
            >`,
  side4Text:
    '作为赛程中的核心赋能环节，导师日特邀来自汇丰银行、数码港及港铁公司的资深行业导师组成专家团队，为十支决赛队伍提供一对一指导。导师们基于金融创新、智慧科技与可持续发展等多元领域经验，围绕专案可行性分析、商业模式优化、技术应用落地及社会影响力拓展等维度，为参赛作品注入行业洞见。通过案例拆解、模拟路演及分组研讨，参赛队伍在数据支撑、逻辑严谨性及方案呈现上实现突破性提升，部分作品更融入跨领域资源联动的新思路，助力学生团队突破创意与落地的“最后一公里”，为决赛角逐奠定扎实基础。',
  side5Text:
    '    历经八个月从创意萌芽、作品迭代到精益打磨的淬炼，十支决赛队伍在终审日迎来“厚积薄发”的巅峰时刻。终审日现场，团队以兼具专业深度与叙事张力的路演，展现方案的多元探索，每份作品皆凝聚著香港青年对环境保护与可持续发展的实践思考。由学界教授、产业领袖及投资人士组成的评审团全程专注，在问答环节与选手展开“火花四溅”的思辨交锋——针对技术瓶颈的破局策略、商业与社会价值的平衡逻辑等议题，评委以犀利提问激发团队更缜密的推演，而选手则以数据化论证与跨界思维回应挑战，让“理论落地”的路径愈发清晰。香港环境保护署署长徐浩光博士，JP. 作为特邀嘉宾亲临现场，与学生们亲切交流，并傅授重要的指导意见。',
  side6Text:
    '作为活动的荣耀收官之章，颁奖典礼特邀多位业内专家为这场青年环保创新盛会赋予权威见证与深切期许。亲身鼓励年轻一代在科学和环境领域不断努力探索，为地区以致全球环境保护做出积极贡献。',
  side7Text:
    ' 第二届「库布其奖」优胜团队在香港亿利公益基金会组织下，走进内蒙古库布其沙漠，开启四天三晚的沙漠实地考察。学生们实地探访阳光谷光氢低碳产业基地，学习光伏治沙与生态修复的前沿技术；走进沙旱生灌木种质中心，见证科技如何让荒漠焕发生机；在七星湖牧民新村与当地居民互动，感受“治沙致富”的可持续模式。通过亲手扎草方格固沙、与沙漠学子交流、体验绿色农牧生活，香港青少年深刻理解了生态治理的艰辛与智慧。这场沉浸式研学以“一带一路”绿色发展视角，将低碳理念化为行动信念，让库布其的绿色种子在年轻心中生根发芽。',
  workTitle2: '第二届库布其大赛-得奖作品',
  photograph: '照片',
  photoWall:'照片墙',
  sustainableMentext:'中学生 - 「谈谈可持续」短片比赛',
  sustainableMentext2:'大学生-国际沙漠可持续发展大赛',
}
